import React from "react";
import styled from "styled-components";

import MoveWithScroll from "@racepointenergy/gatsby-theme-sitespark/src/components/ScrollWatcher/move-with-scroll";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

import DLMBg from "images/dlm_bck2.png";
import DLM1 from "images/GE_Module_1.png";
import DLM2 from "images/GE_Module_2.png";
import DLM3 from "images/GE_Module_3.png";
import DLM4 from "images/GE_Module_4.png";
import DLM5 from "images/GE_Module_5.png";

import {
  Section,
  Card,
  Header2,
  Underlined,
  Paragraph,
  Sizing,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";

const ModuleBgContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModuleImageWrapper = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
`;

const ModulesImage = styled.img`
  max-width: 100%;
  width: auto;
  height: auto;
  max-height: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;

const Module1 = styled(ModulesImage)`
  left: 4%;
  max-width: 32%;
  max-height: unset;
  margin-top: 8%;

  @media screen and (min-width: ${getSize(
      "tablet720"
    )}) and (max-width: 959px) {
    max-width: 40%;
    left: -10%;
    margin-top: 20%;
  }

  @media screen and (max-width: ${getSize("medium")}) {
    max-width: 70%;
    left: -15%;
    margin-top: 15%;
  }
`;
const Module2 = styled(ModulesImage)`
  left: 24%;
  margin-top: -2%;
  max-height: 60%;
  max-width: 24%;

  @media screen and (max-width: ${getSize("medium")}) {
    max-width: 60%;
    left: 28%;
    margin-top: -6%;
  }
`;
const Module3 = styled(ModulesImage)`
  left: 37%;
  margin-top: 1%;
  max-height: 66%;
  max-width: 30%;

  @media screen and (max-width: ${getSize("medium")}) {
    max-width: 60%;
    max-height: 70%;
    left: unset;
    margin-top: 2%;
    right: -19%;
  }
`;
const Module4 = styled(ModulesImage)`
  right: 21%;
  margin-top: -4%;
  max-height: 40%;
  max-width: 14%;

  @media screen and (max-width: ${getSize("medium")}) {
    display: none;
  }
`;
const Module5 = styled(ModulesImage)`
  right: 1%;
  margin-top: -3%;
  max-height: 82%;
  max-width: 30%;

  @media screen and (max-width: ${getSize("medium")}) {
    display: none;
  }
`;

export const FlexibleLoadManagement = () => (
  <Section
    css={`
      @media screen and (min-width: ${getSize("tablet720")}) {
        justify-content: flex-end;
      }
    `}
  >
    <Sizing
      css={`
        background: url("${DLMBg}");
        background-position: 10% 50%;
        background-repeat: norepeat;
        background-size: cover;
      `}
    >
      <ModuleBgContainer>
        <MoveWithScroll scrollMoveDelta={0.27}>
          <ModuleImageWrapper style={{ zIndex: "3" }}>
            <Module1 src={DLM1} />
          </ModuleImageWrapper>
        </MoveWithScroll>
        <MoveWithScroll scrollMoveDelta={0.2}>
          <ModuleImageWrapper style={{ zIndex: "1" }}>
            <Module2 src={DLM2} />
          </ModuleImageWrapper>
        </MoveWithScroll>
        <MoveWithScroll scrollMoveDelta={0.27}>
          <ModuleImageWrapper style={{ zIndex: "2" }}>
            <Module3 src={DLM3} />
          </ModuleImageWrapper>
        </MoveWithScroll>
        <MoveWithScroll scrollMoveDelta={0.14}>
          <ModuleImageWrapper style={{ zIndex: "1" }}>
            <Module4 src={DLM4} />
          </ModuleImageWrapper>
        </MoveWithScroll>
        <MoveWithScroll scrollMoveDelta={0.34}>
          <ModuleImageWrapper style={{ zIndex: "2" }}>
            <Module5 src={DLM5} />
          </ModuleImageWrapper>
        </MoveWithScroll>
      </ModuleBgContainer>
    </Sizing>
    <Card
      css={`
        @media screen and (min-width: ${getSize(
            "default"
          )}) and (max-width: 479px) {
          padding: 33px 38px 35px 38px;
        }
        @media screen and (min-width: ${getSize(
            "mobile480"
          )}) and (max-width: 719px) {
          padding: 34px 42px 46px 46px;
        }
        @media screen and (min-width: ${getSize(
            "tablet720"
          )}) and (max-width: 959px) {
          width: 425px;
          padding: 44px 50px 49px 50px;
        }
        @media screen and (min-width: ${getSize(
            "tablet960"
          )}) and (max-width: 1199px) {
          width: 438px;
          padding: 30px 39px 34px 39px;
        }
        @media screen and (min-width: ${getSize(
            "desktop1200"
          )}) and (max-width: 1919px) {
          width: 504px;
          padding: 41px 48px;
        }
        @media screen and (min-width: ${getSize("desktop1920")}) {
          padding: 74px 80px;
          width: 626px;
        }
      `}
    >
      <Header2>
        {"Flexible Load Management"}
        <Underlined />
      </Header2>
      <Paragraph
        css={`
          @media screen and (min-width: ${getSize(
              "default"
            )}) and (max-width: 479px) {
            margin-top: 20px;
          }
          @media screen and (min-width: ${getSize(
              "mobile480"
            )}) and (max-width: 719px) {
            margin-top: 19px;
          }
          @media screen and (min-width: ${getSize(
              "tablet720"
            )}) and (max-width: 959px) {
            margin-top: 20px;
          }
          @media screen and (min-width: ${getSize("tablet960")}) {
            margin-top: 23px;
          }
        `}
      >
        {
          "Looking to maximize the use of your solar array, keep your home or business powered through a grid failure, or just looking to save money on your energy bills? Savant Power's Flexible Load Management provides circuit level energy monitoring and control over every load in your home or business giving you the ability to take back control over your energy."
        }
      </Paragraph>
    </Card>
  </Section>
);
